import { getQuickContactSchema } from "./quickContactSchema";
import { api } from "../../common/utils/api";

export const initQuickContactForm = () => {
  const form = document.getElementById("quickContactForm") as HTMLFormElement;
  if (!form) return;

  const translations =
    (window as any).commonVariables?.translations?.quickContactForm || {};

  const submitBtn = form.querySelector(".submit-btn") as HTMLButtonElement;
  const successMsg = form.querySelector(".qcf-success-message") as HTMLElement;
  const errorMsg = form.querySelector(".qcf-error-message") as HTMLElement;

  const originalBtnHtml = submitBtn?.innerHTML || "";

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Reset UI states
    if (successMsg) successMsg.style.display = "none";
    if (errorMsg) errorMsg.style.display = "none";
    form
      .querySelectorAll(".has-error")
      .forEach((el) => el.classList.remove("has-error"));

    const formData = new FormData(form);
    const rawData = Object.fromEntries(formData.entries());

    const result = getQuickContactSchema().safeParse(rawData);

    if (!result.success) {
      if (errorMsg) {
        errorMsg.style.display = "block";
        errorMsg.innerText =
          translations.errorValidation || "Please check your inputs.";
      }

      Object.keys(result.error.flatten().fieldErrors).forEach((field) => {
        const input = form.querySelector(`[name="${field}"]`);
        if (input) input.classList.add("has-error");
      });
      return;
    }

    // Loading State
    if (submitBtn) {
      submitBtn.disabled = true;
      const spans = submitBtn.querySelectorAll("span");
      spans.forEach((span) => {
        const svg = span.querySelector("svg");
        span.innerText = (translations.sending || "Sending...") + " ";
        if (svg) span.appendChild(svg);
      });
    }

    try {
      await api.post("/forms/quick-contact", result.data);

      form.reset();
      if (successMsg) {
        successMsg.style.display = "block";
        successMsg.innerText = translations.successMessage || "Message sent!";
      }
    } catch (err: any) {
      if (errorMsg) {
        errorMsg.style.display = "block";
        errorMsg.innerText =
          err.message || translations.errorGeneral || "An error occurred.";
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnHtml; // Restore SVG hover blocks
      }
    }
  });
};
